import type { Nullable } from '../types'
import type { Region, RegionAutocomplete } from '../types/regions'
import type { GolfLite } from '../types/shared'

export const useRegionsService = () => {
  const config = useRuntimeConfig()
  const BASE_URL = `${config.public.apiBase}/api/regions`

  return {
    getRegions() {
      return fetchJson<FetchResult<Region[]>>(
        'GET', `${BASE_URL}`,
      )
    },
    getRegion(regionId: string) {
      return fetchJson<FetchResult<Region>>(
        'GET', `${BASE_URL}/${regionId}`,
      )
    },
    getRegionGolfs(regionId: Nullable<number>) {
      if (!regionId) {
        throw Error('Missing regionId')
      }
      return fetchJson<FetchResult<GolfLite[]>>(
        'GET', `${BASE_URL}/${regionId}/golfs`,
      )
    },
    getRegionsAutocomplete(name: string) {
      return fetchJson<FetchResult<RegionAutocomplete[]>>(
        'GET', `${BASE_URL}/autocomplete?nom=${name}`,
      )
    },
  }
}
